export enum ResourcePath {
  summary = 'summary',
  article = 'article',
  link = 'link',
  book = 'book',
  academicWork = 'academic-work',
}
